<p-card styleClass="very-compact-card p-3">
  <h3 class="m-0">Созданные заявки HelpDesk</h3>
  <div class="my-3">
    <crm-table
      *ngIf="tasks?.length && !loading"
      [columns]="columns"
      [values]="tasks"
      styleClass="sticky-header p-datatable-sm">
      <ng-template
        #rowTemplate
        let-task="item">
        <tr *ngIf="toTask(task) as task">
          <td>
            <a
              class="white-space-nowrap"
              crmConditionalRouterLink
              [routerLink]="['/helpdesk/task/card/', task.id]">
              Заявка №{{ task.id }}
            </a>
          </td>
          <td>
            <div class="text-sm text-400">
              {{ task.created | date: 'dd.MM.yyyy' }}
            </div>
          </td>
        </tr>
      </ng-template>
    </crm-table>

    <p
      *ngIf="!tasks?.length && !loading"
      class="text-xl font-medium">
      Нет заявок
    </p>

    <crm-spinner
      *ngIf="loading"
      top="mt-4"></crm-spinner>
  </div>

  <div class="flex">
    <a
      *ngIf="tasks?.length && !loading"
      pButton
      label="в список"
      class="p-button-round p-button-text p-button-sm p-button-info cursor-pointer -ml-3"
      icon="pi pi-external-link"
      (click)="directToTasksList.emit()"></a>
  </div>
</p-card>
